import React, { useEffect, useRef } from "react";

/**
 * Google AdSense ad slot for Sarthi Associates.
 *
 * Publisher ID (ca-pub-9116527956451933) is loaded globally in /public/index.html.
 * This component only renders one <ins> unit and calls (adsbygoogle = window.adsbygoogle || []).push({})
 * on mount. Re-renders across route changes safely re-initialize because <ins> is keyed by slot.
 *
 * Notes:
 *   - Real ads only render after Google approves the site (24-72h post first crawl).
 *     Until then the slot renders empty — which is fine.
 *   - `layout="in-feed"` maps to `data-ad-format="fluid"` + a `data-ad-layout-key`.
 *   - `layout="in-article"` is a native long-form ad, works well inside blog posts.
 *   - `layout="display"` is a plain responsive banner.
 */
export default function AdSlot({
  slot,
  layout = "display",
  layoutKey,
  className = "",
  style,
}) {
  const insRef = useRef(null);

  useEffect(() => {
    try {
      // eslint-disable-next-line no-multi-assign
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (_) { /* AdSense not yet loaded — will retry on next mount */ }
  }, [slot]);

  const attrs = {
    className: "adsbygoogle",
    style: { display: "block", ...(style || {}) },
    "data-ad-client": "ca-pub-9116527956451933",
    "data-ad-slot": slot,
  };
  if (layout === "in-feed") {
    attrs["data-ad-format"] = "fluid";
    if (layoutKey) attrs["data-ad-layout-key"] = layoutKey;
  } else if (layout === "in-article") {
    attrs["data-ad-format"] = "fluid";
    attrs["data-ad-layout"] = "in-article";
  } else {
    attrs["data-ad-format"] = "auto";
    attrs["data-full-width-responsive"] = "true";
  }

  return (
    <div className={className} data-testid={`ad-slot-${slot}`}>
      <ins ref={insRef} {...attrs} />
    </div>
  );
}
